/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Asset } from './asset';

/**
 * Volume statistic per asset
 */
export interface AssetDataDto {
  asset: Asset;
  volume: number;
  revenue: number;
  volumeInUsd: number;
  revenueInUsd: number;
}
